<script setup lang="ts">
import { Tippy } from 'vue-tippy';
import { HelpCircle } from 'lucide-vue-next';

import { Card } from '@/components/ui/Card';

import { POSITION_TOP } from '@/constants/layout';

import type { ParseKeys } from 'i18next';

defineProps<{
  title: ParseKeys;
  tooltip: ParseKeys;
}>();
</script>

<template>
  <Card
    class="p-5 flex-col justify-start items-start gap-2.5 inline-flex"
    :data-testid="`statistic-card-${title}`"
  >
    <div class="flex gap-2.5 items-center">
      <p class="text-sm" data-testid="statistic-card-title">
        {{ $t(title) }}
      </p>
      <Tippy :content="$t(tooltip)" :placement="POSITION_TOP">
        <HelpCircle
          class="shrink-0 h-4 w-4"
          stroke-width="{1}"
          data-testid="help-circle-icon"
        />
      </Tippy>
    </div>
    <slot></slot>
  </Card>
</template>
